import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '../../ui-components';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.element,
  fluid: PropTypes.string
};

/**
 * Component that renders an image as a gatsby-background-image
 *
 * @component BackgroundHeroPreview
 * 
 * @param {object} props
 * 
 * @prop {string} className
 * @prop {object} children
 * @prop {string} image
 * 
 * @return {JSX}
 */
const BackgroundHeroPreview = props => {
  const { className, children, image } = props;
  
  return (
    <HeroWrapper>
      <Background
        imageUrl={image}
        className={className}>
        {children}
      </Background>
    </HeroWrapper>
  );
};

const HeroWrapper = styled.div`
  width: 100%;
  background-position: bottom center;
  background-repeat: repeat-y;
  background-size: cover;
`;

const Background = styled.div`
  background-image: url(${props => props.imageUrl});
  background-size: cover;
  background-color: ${colors.midnightBlack};
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 400px;
`;

BackgroundHeroPreview.propTypes = propTypes;

export default BackgroundHeroPreview;
